import api from "./api";

// Templates
export const listContratoTemplates = async () => {
  const { data } = await api.get("/contrato-templates");
  return data;
};

export const getContratoTemplate = async (id) => {
  const { data } = await api.get(`/contrato-templates/${id}`);
  return data;
};

export const createContratoTemplate = async (payload) => {
  const { data } = await api.post("/contrato-templates", payload);
  return data;
};

export const updateContratoTemplate = async (id, payload) => {
  const { data } = await api.put(`/contrato-templates/${id}`, payload);
  return data;
};

export const deleteContratoTemplate = async (id) => {
  await api.delete(`/contrato-templates/${id}`);
};

export const uploadContratoLogo = async (file, companyId) => {
  const form = new FormData();
  form.append("logo", file);
  const { data } = await api.post("/contrato-templates/upload-logo", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data.url;
};

// Contratos
export const listContratos = async (params = {}) => {
  const { data } = await api.get("/contratos", { params });
  return data;
};

export const getContrato = async (id) => {
  const { data } = await api.get(`/contratos/${id}`);
  return data;
};

export const createContrato = async (payload) => {
  const { data } = await api.post("/contratos", payload);
  return data;
};

export const updateContrato = async (id, payload) => {
  const { data } = await api.put(`/contratos/${id}`, payload);
  return data;
};

export const deleteContrato = async (id) => {
  await api.delete(`/contratos/${id}`);
};

export const sendContrato = async (id) => {
  const { data } = await api.post(`/contratos/${id}/send`);
  return data;
};
